import ArbitratorUpload from "./ArbitratorUpload";

export default ArbitratorUpload;
